// extracted by mini-css-extract-plugin
export default {"emojiPickerContainer":"EmojiPicker_emojiPickerContainer__o4MsQ","emojiPickerContainerAugRev":"EmojiPicker_emojiPickerContainerAugRev__u2KSr"};